<template>
  <div class="page-wrapper container-custom">
    <div class=" row    image-wrapper">
      <div class="col-md-6 mb-4  mb-lg-0">
        <div class="map">
          <GoogleMap
              style="width: 100%;
                height: 100%"
              api-key="AIzaSyCp_uEUH8N2Bwi10lwpIX9pIUgSdCCI8hM"
              :zoom="13"
              :center="{lat: 42.652283213638114, lng: 23.287859280076972}"
              :styles="mapOptions"
              :disableDefaultUi="true">
            <Marker :options="marker"/>
          </GoogleMap>
        </div>
      </div>
      <div class="col-md-6   d-flex  align-items-center  ">
        <div class="brown-background">
          <ContactsContent :button-icon="contacts.buttonIcon"
                           :button-text="contacts.buttonText"
                           :item1="contacts.item1"
                           :item2="contacts.item2"
                           :item3="contacts.item3"
                           :item4="contacts.item4"
                           :item5="contacts.item5"
                           :placeholder1="contacts.placeholder1"
                           :placeholder2="contacts.placeholder2"
                           :placeholder3="contacts.placeholder3"
                           :placeholder4="contacts.placeholder4"
                           :title="contacts.title"
                           class="contacts-wrapper"
          >
            <div class="mt-4  button-inquiry" @click="showModal">
              <MainButton :button-text="contacts.buttonText" :icon="contacts.buttonIcon" :size="'medium'"
                          :theme="'solid-blue'"/>
            </div>
          </ContactsContent>
        </div>
      </div>
    </div>
    <div>
      <ModalMain ref="modalComponent">
        <div>
          <ModalContacts :button-text="contactModal.buttonText"
                         :placeholder-contact="contactModal.placeholderContact"
                         :placeholder-message="contactModal.placeholderMessage"
                         :placeholder-name="contactModal.placeholderName"
                         :subtitle="contactModal.subtitle"
                         :title="contactModal.title"
                         @onFormSubmit="handleContactFormSubmit"
          />
        </div>
      </ModalMain>
    </div>
  </div>
</template>

<script>
import ContactsContent from "@/components/Components/ContactsContent/ContactsContent.vue";
import ModalMain from "@/components/Components/ModalMain/ModalMain.vue";
import ModalContacts from "@/components/Components/ModalMain/ModalContacts.vue";
import MainButton from "@/components/Common/Buttons/MainButton.vue";
import axios from "axios";
import {GoogleMap, Marker} from 'vue3-google-map';
import mapOptions from "@/utils/MapOptions";

export default {
  name: 'ContactsView',
  components: {GoogleMap, Marker, MainButton, ModalContacts, ModalMain, ContactsContent},
  props: {},
  data() {
    return {
      contacts: {},
      contactModal: {},
      marker: {
        position: {
          lat: 42.652283213638114,
          lng: 23.287859280076972
        },
        icon: {
          url: '/static/images/marker-pin.png',
          size: {width: 30, height: 50},
          anchor: {x: 20, y: 20},
          // scaledSize: { width: 40, height: 40 },
          // labelOrigin: { x: 20, y: -10 },
        },
      }
    }
  },
  computed: {
    mapOptions() {
      return mapOptions;
    }
  },
  mounted() {
    this.contacts = {
      title: this.$t('contacts-title'),
      placeholder1: this.$t('contacts-phone-placeholder'),
      placeholder2: 'Email',
      placeholder3: this.$t('contacts-address-placeholder'),
      placeholder4: this.$t('contacts-working-hours-placeholder'),
      item1: this.$t('contacts-phone-number'),
      item2: this.$t('contacts-email-address'),
      item3: this.$t('contacts-hospital-address'),
      item4: this.$t('contacts-working-days-working-hours'),
      item5: this.$t('contacts-rest-days'),
      buttonText: this.$t('send-inquiry'),
      buttonIcon: 'arrow-forward'
    };
    this.contactModal = {
      title: this.$t('contacts-modal-title'),
      subtitle: this.$t('contacts-modal-subtitle'),
      placeholderName: this.$t('your-name-placeholder'),
      placeholderContact: this.$t('your-phone-email-placeholder'),
      placeholderMessage: this.$t('your-message-placeholder'),
      buttonText: this.$t('button-send'),
    }
  },
  methods: {
    showModal() {
      this.$refs.modalComponent.showModal();
    },
    async handleContactFormSubmit(form) {
      await this.$recaptchaLoaded()
      const token = await this.$recaptcha('login')

      this.$refs.modalComponent.hideModal();

      try {
        await axios.post('/api/contact', {...form, token})
      } catch (err) {
        await this.$store.dispatch("utils/openNotificationModal", {
          type: 'error',
          message: this.$t('contact-form-error')
        });
        return;
      }

      await this.$store.dispatch("utils/openNotificationModal", {
        type: 'success',
        message: this.$t('contact-form-success')
      });

      this.form = {name: null, contact: null, message: null};
    }
  },
}
</script>

<style lang="scss" scoped>
@import "~@/assets/scss/fonts.scss";

.page-wrapper {
  font-family: $font-regular;
  margin: 120px 0 $spacing-5;
}

.brown-background {
  background: $color-light-brown;
  border-radius: 30px;
  width: 100%;
  height: 100%;
}

.contacts-wrapper {
  padding: 40px 20px;
}

.inner-wrapper {

  padding: 40px 20px;
}

.image-wrapper {
  border-radius: 30px;
  min-height: 480px;
  overflow: hidden;

  .map-image {
    background-image: url("@/assets/images/map-image.webp");
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center;
    width: 100%;
    border-radius: 30px;
    min-height: 480px;

  }
  .map {
    height: 100%;
    min-height: 400px;
    width: 100%;
  }
}


@media screen and (min-width: 768px) {

  .contacts-wrapper {
    padding: 40px;

  }
  .image-wrapper {
    .map-image {
      min-height: 100%;
    }
  }
  .button-inquiry {
    max-width: 250px;
  }
}

@media screen and (min-width: 1500px) {
  .contacts-wrapper {
    padding: 50px;
    width: 90%;
  }

}
</style>